import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment FeaturesSimpleHeaderData on StrapiComponentFeaturesSimpleHeader {
    title
    topic
    body {
      ...StrapiSharedBody
    }
  }
`;

function SimpleHeader({ data }) {
  if (!data) {
    return <></>;
  }
  return (
    <div className="overflow-hidden bg-background-white pb-4 pt-16 lg:pb-8 lg:pt-24">
      <div className="mx-auto max-w-xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="">
          {data.topic && (
            <h3 className="text-center text-base font-semibold uppercase tracking-wide text-text-primary">
              <MarkdownWrapper text={data.topic} />
            </h3>
          )}
          {data.title && (
            <h2 className="text-center text-3xl font-extrabold leading-8 tracking-tight text-text-primary sm:text-4xl">
              <MarkdownWrapper text={data.title} />
            </h2>
          )}
          {data.body?.text && (
            <MarkdownWrapper
              text={data.body.text}
              images={data.body.images}
              markdownClassName="mt-4 max-w-3xl mx-auto text-center text-xl text-text-secondary"
              replaceParagraph={false}
            />
          )}
        </div>
      </div>
    </div>
  );
}

SimpleHeader.propTypes = {
  data: PropTypes.object,
};

export default SimpleHeader;
